import React from 'react'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Badge from '@material-ui/core/Badge'
import Card from '@material-ui/core/Card'
import Loading from '../../Container/Loading/Loading'
import withWidth from '@material-ui/core/withWidth'
import { compose } from 'recompose'
import _ from 'lodash'
import InboxItemDetails from './MessagingConfirmedEventDetails'
import Fade from '@material-ui/core/Fade'
import { getDateFormated } from '../../js/helper'
//import moment from 'moment'


const styles = theme =>({
    inboxPaper: {
        padding: theme.spacing.unit,
        paddingTop: theme.spacing.unit *3 + 'px!important',
        //width: '100%',
        [theme.breakpoints.down('sm')]: {
        padding: theme.spacing.unit,
        }
    },
    titleWrapper: {
        marginBottom: theme.spacing.unit,

    },
    header: {
        borderRadius: '8px 8px 0 0',
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        padding: theme.spacing.unit,
    },
    inboxBadge: {
        top: '-4px',
        right: '-24px'
    }
})


const MessagingConfiremdEvents = (props) => {

    const { classes, items, itemClickCallback, itemCounter, clickedItemId, clickedArrIndex, functions } = props

    const isMobile = () => {
        return props.width === 'sm' || props.width === 'xs'
            ? true
            : false
    }

    const renderInboxHeader = (
        <Grid style={{marginBottom: '8px'}} item xs={12} md={12}>
                <Card className={classes.header}>
                    <Grid container alignItems='flex-start'>
                        <Grid item xs={12} md={3}>
                           <HeaderProp title='Datum' />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <HeaderProp title='Hilesuchender' />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <HeaderProp title='Hilfegesuch' />
                        </Grid>
                    </Grid>
                 </Card>
        </Grid>
    )

 
    
    const renderItemDetails = clickedArrIndex!==null
    ?<InboxItemDetails 
        //closeBtn={functions.closeBtnItemDetails}
        //requesterData={clickedRequesterData}
        event={items[clickedArrIndex]}
        requesterData={items[clickedArrIndex].requester}
        functions={functions.itemDetails}
    />
    : null

    const renderInboxItems = (
        _.map(items, (item, index) =>
            <Grid style={{marginBottom: '8px'}} key={index} item xs={12} md={12}>
            <div onClick={()=>itemClickCallback(item.event.id, index)}>
                <InboxItem 
                        item={item}
                        isMobile={isMobile()}
                        clickedItemId={clickedItemId}
                    />
                </div>
                {clickedItemId===item.event.id && isMobile()===true
                        ? renderItemDetails
                        : null}
            </Grid>
        )
    )
    return (
        <Grid container spacing={8} alignItems='flex-start' >
        <Grid item xs={12} md={6} >
            <Paper className={classes.inboxPaper}>
                <div className={classes.titleWrapper} >
                    <Badge classes={{ badge: classes.inboxBadge }} badgeContent={itemCounter || 0} color={itemCounter ? 'primary' :'secondary'} >
                        <Title title ='Vermittelte Hilfeangebote' />     
                    </Badge>
                </div>
                <div>
                    {renderInboxHeader}
                    {!items
                        ? <Loading text='Vermittelte Hilfeangebot werden geladen...' />
                        : items.length===0 ? <span style={{padding: '8px', fontWeight: 'bold'}}>Keine Vermittlungen vorhanden!</span> : renderInboxItems
                    }
                </div>
            </Paper>
            
        </Grid>
        <Grid item xs={12} md={6} >
                {isMobile()===false
                    ? renderItemDetails
                    : null}
            
        </Grid>
    </Grid>
    )
}

const HeaderProp =  ({title, style}) => <Typography style={style || {}} variant='subheading' color='inherit' >{title}</Typography>
const Title =  ({title, style}) => <Typography style={style || {}} variant='title' color='primary' >{title}</Typography>

const InboxItem = ({item, clickedItemId}) => {

    const style = {
        inboxItem : {
            padding: '8px',
            cursor: 'pointer',
            backgroundColor: clickedItemId===item.event.id ? '#7986cb' : '',
            color: clickedItemId===item.event.id ? 'white' : ''
        }
    }
 
    return (
        <Fade in={true}>
                <Card
                    style={style.inboxItem}
                >
                    <Grid container spacing={0} alignItems='flex-start'>
                        <Grid item xs={12} md={3}>
                            <div>{getDateFormated(item.event.date, 'normal')}</div>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <div>{item.requester.name}</div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <div style={{overflow: 'hidden'}}>{item.event.task}</div>
                        </Grid>
                    </Grid>
                </Card>
            </Fade>
    )
}

export default compose (
    withStyles(styles),
    withWidth()
)(MessagingConfiremdEvents)


// WEBPACK FOOTER //
// ./src/Components/MessagingCenter/MessagingConfirmedEvents.js